import { ScreenerSettingName } from '@/hooks/screener-settings';

import { useScreenerSettingFindOne } from './useScreenerSettingsQuery';

export function useGetScreenerSettingValue(settingName: ScreenerSettingName) {
  const { data, isLoading } = useScreenerSettingFindOne({ settingName });
  return {
    value: data?.data?.value,
    isLoading
  };
}
